import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccVentureEntrepreneur } from '@interfaces';
import { AccVentureDialogDataService } from '../../acc-venture-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService, dialogDataService: AccVentureDialogDataService): GridSetup<AccVentureEntrepreneur> {

	return {
		rowName: { singular: 'Entrepreneur', plural: 'Entrepreneurs' },
		getRowKey: row => '' + row.accEntrepreneurId,
		stateKey: 'acc-venture-entrepreneurs-grid',
		actions: getActions(dialog, dialogDataService),
		buttons: getButtons(dialog, dialogDataService),
		columns: getColumns(util),
	}
}
